(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7894],{

/***/ 63285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CompareBrokerQuickLinks; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _shared_QuickLinks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87160);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15746);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




function CompareBrokerQuickLinks(_ref) {
  var brokers = _ref.brokers;
  return brokers.map(function (broker, idx) {
    var linkList = [];
    var _broker$attributes = broker.attributes,
        name = _broker$attributes.name,
        slug = _broker$attributes.slug,
        commodityTrading = _broker$attributes.commodity_trading,
        currencyTrading = _broker$attributes.currency_trading;
    linkList.push({
      href: '/broker/[slug]',
      as: "/broker/".concat(slug),
      linkText: " ".concat(name, " Review")
    });

    if (commodityTrading) {
      linkList.push({
        href: '/broker/[slug]/commodity-trading',
        as: "/broker/".concat(slug, "/commodity-trading"),
        linkText: " ".concat(name, " Commodity Trading")
      });
    }

    if (currencyTrading) {
      linkList.push({
        href: '/broker/[slug]/currency-trading',
        as: "/broker/".concat(slug, "/currency-trading"),
        linkText: " ".concat(name, " Currency Trading")
      });
    }

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      style: {
        marginBottom: '16px'
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        span: 24,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          title: "".concat(name, " Quick Links"),
          linkList: linkList
        })
      })
    }, idx);
  });
}

/***/ }),

/***/ 50590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ArticleTags; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15746);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51904);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






function ArticleTags(_ref) {
  var categories = _ref.categories,
      broker = _ref.broker,
      software = _ref.software,
      _ref$page = _ref.page,
      page = _ref$page === void 0 ? null : _ref$page;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    gutter: [0, 16],
    style: {
      marginBottom: 0
    },
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      span: 23,
      children: [categories ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
        children: [page === 'article' ? 'Categories: ' : null, categories.map(function (category, i) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: "/faqs/[slug]/",
            as: "/faqs/".concat(category.attributes.slug, "/"),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
              color: broker ? '#55acee' : '#3b5999',
              children: category.attributes.name
            }, i)
          }, i);
        })]
      }) : null, broker ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "/broker/[slug]",
        as: "/broker/".concat(broker.attributes.slug),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
          color: "#3b5999",
          children: [" ", broker.attributes.name]
        })
      }) : null, software ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "/software/[slug]",
        as: "/software/".concat(software.attributes.slug),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
          color: "#cd201f",
          children: software.attributes.name
        })
      }) : null]
    })
  });
}

/***/ }),

/***/ 3270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DetailsWithPhoto; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38456);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_markdown__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





function DetailsWithPhoto(_ref) {
  var details = _ref.details,
      image = _ref.image;
  if (!details) return null;
  var photo = image !== null && image !== void 0 && image.file.data[0] ? image : null;
  var description = details.split('\n');
  var lis = [];

  for (var i = 1; i < details.length; i += 1) {
    lis.push( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((react_markdown__WEBPACK_IMPORTED_MODULE_1___default()), {
      children: description[i]
    }, i));
  }

  var myLoader = function myLoader(_ref2) {
    var src = _ref2.src;
    return src;
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((react_markdown__WEBPACK_IMPORTED_MODULE_1___default()), {
      children: description[0]
    }), photo ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
      loader: myLoader,
      src: photo.file.data[0].attributes.url,
      height: 900,
      width: 1200,
      layout: "responsive"
    }) : null, lis]
  });
}

/***/ }),

/***/ 87160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ QuickLinks; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38456);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_markdown__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87547);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88641);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15746);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3679);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);










var titleFormat = function titleFormat(linkTitle, icon) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [icon, " ".concat(linkTitle)]
  });
};

function QuickLinks(props) {
  var icon = props.icon,
      title = props.title,
      linkList = props.linkList,
      country = props.country;
  if (linkList < 1 || linkList === 'undefined') return null;
  return linkList ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [country === 'India' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      style: {
        paddingBottom: '32px'
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        style: {
          minWidth: '250px'
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
          target: "_blank",
          href: "https://bit.ly/2YUNebF",
          rel: "noreferrer",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            width: 252,
            height: 302,
            alt: "",
            "data-src": "https://assets.fintrakk.com/Zerodha-Banner-252x302.png",
            src: "https://assets.fintrakk.com/Zerodha-Banner-252x302.png"
          })
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z // eslint-disable-next-line prettier/prettier
    , {
      title: titleFormat(title, icon),
      size: "small",
      bordered: false,
      style: {
        // float: 'right',
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
        borderRadius: '2px',
        minWidth: '100%',
        marginBottom: '16px'
      },
      headStyle: {
        background: '#E6F7FF',
        padding: '5px 0px 0px 25px'
      },
      bodyStyle: {
        padding: '15px 20px 0px 25px',
        minWidth: '272px'
      },
      children: linkList.map(function (qlink, i) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          style: {
            marginBottom: '1em'
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            href: qlink.href,
            as: qlink.as,
            children: qlink.linkText
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("br", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            style: {
              fontSize: '10px'
            },
            children: qlink.textDescription !== 'null' ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_markdown__WEBPACK_IMPORTED_MODULE_1___default()), {
              children: qlink.textDescription
            }) : null
          })]
        }, i);
      })
    })]
  }) : null;
}
QuickLinks.defaultProps = {
  icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
};

/***/ }),

/***/ 28262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ ArticleJsonLd; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_stripMarkdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66252);
/* harmony import */ var shared_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77713);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);




var ArticleJsonLd = function ArticleJsonLd(_ref) {
  var keyOverride = _ref.keyOverride,
      url = _ref.url,
      title = _ref.title,
      _ref$images = _ref.images,
      images = _ref$images === void 0 ? [] : _ref$images,
      _ref$authorName = _ref.authorName,
      authorName = _ref$authorName === void 0 ? 'Fintrakk Admin' : _ref$authorName,
      description = _ref.description,
      _ref$publisherName = _ref.publisherName,
      publisherName = _ref$publisherName === void 0 ? 'Fintrakk' : _ref$publisherName;
  var jsonld = "{\n    \"@context\": \"https://schema.org\",\n    \"@type\": \"Article\",\n    \"mainEntityOfPage\": {\n      \"@type\": \"WebPage\",\n      \"@id\": \"".concat(url, "\"\n    },\n    \"headline\": \"").concat(title, "\",\n    \"image\": [\n      ").concat(images.map(function (image) {
    return "\"".concat(image, "\"");
  }), "\n     ],\n    \"author\": \"").concat(authorName, "\",\n    \"publisher\": {\n      \"@type\": \"Organization\",\n      \"name\": \"").concat(publisherName, "\",\n      \"logo\": {\n        \"@type\": \"ImageObject\",\n        \"url\": \"").concat(shared_util__WEBPACK_IMPORTED_MODULE_2__/* .logoUrl */ .P6, "\"\n      }\n    },\n    \"description\": ").concat((0,_utils_stripMarkdown__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(description), "\n  }");
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: jsonld
    }
  }, "jsonld-article".concat(keyOverride ? "-".concat(keyOverride) : ''));
};

/***/ }),

/***/ 66252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ stripMarkdown; }
/* harmony export */ });
/* harmony import */ var remove_markdown__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26525);
/* harmony import */ var remove_markdown__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(remove_markdown__WEBPACK_IMPORTED_MODULE_0__);

function stripMarkdown(text) {
  return JSON.stringify(remove_markdown__WEBPACK_IMPORTED_MODULE_0___default()(text));
}

/***/ }),

/***/ 30806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Article; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(12922);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(50880);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/es/divider/index.js + 1 modules
var divider = __webpack_require__(96074);
// EXTERNAL MODULE: ./components/comparebroker/CompareBrokerQuickLinks.tsx
var CompareBrokerQuickLinks = __webpack_require__(63285);
// EXTERNAL MODULE: ./components/shared/QuickLinks.tsx
var QuickLinks = __webpack_require__(87160);
// EXTERNAL MODULE: ./components/comments/Comments.tsx + 1 modules
var Comments = __webpack_require__(35428);
// EXTERNAL MODULE: ./components/shared/ArticleTags.tsx
var ArticleTags = __webpack_require__(50590);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/article/ArticleCategories.tsx



function ArticleCategories(_ref) {
  var categories = _ref.categories;
  if (categories < 1 || categories === undefined) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ArticleTags/* default */.Z, {
    categories: categories,
    page: "article"
  });
}
// EXTERNAL MODULE: ./node_modules/antd/es/tag/index.js + 3 modules
var es_tag = __webpack_require__(51904);
;// CONCATENATED MODULE: ./components/article/ArticleTags.js




function ArticleTags_ArticleTags(_ref) {
  var tags = _ref.tags;
  if (!tags) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
    gutter: [0, 16],
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
      span: 23,
      children: ['Tagged With: ', tags.map(function (tag, i) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(es_tag/* default */.Z, {
          color: "blue",
          children: tag
        }, i);
      })]
    })
  });
}
ArticleTags_ArticleTags.defaultProps = {
  tags: []
};
// EXTERNAL MODULE: ./node_modules/react-markdown/src/react-markdown.js
var react_markdown = __webpack_require__(38456);
var react_markdown_default = /*#__PURE__*/__webpack_require__.n(react_markdown);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/UserOutlined.js + 1 modules
var UserOutlined = __webpack_require__(87547);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CheckOutlined.js
var CheckOutlined = __webpack_require__(88284);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/MenuUnfoldOutlined.js + 1 modules
var MenuUnfoldOutlined = __webpack_require__(19944);
// EXTERNAL MODULE: ./node_modules/antd/es/typography/index.js + 20 modules
var typography = __webpack_require__(51945);
// EXTERNAL MODULE: ./node_modules/antd/es/avatar/index.js + 8 modules
var avatar = __webpack_require__(37911);
// EXTERNAL MODULE: ./node_modules/antd/es/card/index.js + 17 modules
var card = __webpack_require__(3679);
// EXTERNAL MODULE: ./components/shared/DetailsWithPhoto.tsx
var DetailsWithPhoto = __webpack_require__(3270);
;// CONCATENATED MODULE: ./components/shared/OptinInline.tsx




var OptinInline = function OptinInline(_ref) {
  var id = _ref.id;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
    style: {
      justifyContent: 'center'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      id: id
    })
  });
};

/* harmony default export */ var shared_OptinInline = (OptinInline);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./components/article/TitleAndDescription.tsx











var Title = typography/* default.Title */.Z.Title;

var TitleWithAuthor = function TitleWithAuthor(_ref) {
  var _user$data, _user$data$attributes, _user$data2, _user$data2$attribute, _user$data3, _user$data3$attribute;

  var title = _ref.title,
      user = _ref.user;
  return (
    /*#__PURE__*/
    // @ts-ignore-next-line
    (0,jsx_runtime.jsx)("div", {
      style: {
        margin: '0.5em 0',
        textWrap: 'pretty'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
        style: {
          display: 'flex'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
          span: 20,
          style: {
            display: 'flex',
            alignItems: 'center'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            style: {
              marginRight: '1em'
            },
            children: [((_user$data = user.data) === null || _user$data === void 0 ? void 0 : (_user$data$attributes = _user$data.attributes) === null || _user$data$attributes === void 0 ? void 0 : _user$data$attributes.avatar) && /*#__PURE__*/(0,jsx_runtime.jsx)(avatar/* default */.C, {
              src: user.data.attributes.avatar,
              size: 55
            }), !((_user$data2 = user.data) !== null && _user$data2 !== void 0 && (_user$data2$attribute = _user$data2.attributes) !== null && _user$data2$attribute !== void 0 && _user$data2$attribute.avatar) && /*#__PURE__*/(0,jsx_runtime.jsx)(avatar/* default */.C, {
              size: 32,
              icon: /*#__PURE__*/(0,jsx_runtime.jsx)(UserOutlined/* default */.Z, {})
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
              level: 2,
              style: {
                marginBottom: 0
              },
              children: title
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography/* default.Text */.Z.Text, {
              disabled: true,
              children: (_user$data3 = user.data) === null || _user$data3 === void 0 ? void 0 : (_user$data3$attribute = _user$data3.attributes) === null || _user$data3$attribute === void 0 ? void 0 : _user$data3$attribute.username
            })]
          })]
        })
      })
    })
  );
};

var CreatedAction = function CreatedAction(_ref2) {
  var _user$data4, _user$data4$attribute, _user$data5, _user$data5$attribute, _user$data6, _user$data6$attribute;

  var user = _ref2.user;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    style: {
      marginLeft: '1em'
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(typography/* default.Text */.Z.Text, {
        children: "Asked By"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(row/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
        style: {
          marginRight: '0.5em'
        },
        children: [((_user$data4 = user.data) === null || _user$data4 === void 0 ? void 0 : (_user$data4$attribute = _user$data4.attributes) === null || _user$data4$attribute === void 0 ? void 0 : _user$data4$attribute.avatar) && /*#__PURE__*/(0,jsx_runtime.jsx)(avatar/* default */.C, {
          src: user.data.attributes.avatar
        }), !((_user$data5 = user.data) !== null && _user$data5 !== void 0 && (_user$data5$attribute = _user$data5.attributes) !== null && _user$data5$attribute !== void 0 && _user$data5$attribute.avatar) && /*#__PURE__*/(0,jsx_runtime.jsx)(avatar/* default */.C, {
          size: 32,
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(UserOutlined/* default */.Z, {})
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(typography/* default.Text */.Z.Text, {
          children: (_user$data6 = user.data) === null || _user$data6 === void 0 ? void 0 : (_user$data6$attribute = _user$data6.attributes) === null || _user$data6$attribute === void 0 ? void 0 : _user$data6$attribute.username
        })
      })]
    })]
  });
};

var UpdatedAction = function UpdatedAction(_ref3) {
  var updatedAt = _ref3.updatedAt;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    style: {
      marginLeft: '1em'
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(typography/* default.Text */.Z.Text, {
        children: "Updated On:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
        style: {
          marginRight: '0.5em'
        },
        children: dayjs_min_default()(updatedAt).format('DD-MMM-YYYY')
      })
    })]
  });
};

var RepliesAction = function RepliesAction(_ref4) {
  var comments = _ref4.comments;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    style: {
      marginLeft: '1em'
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(typography/* default.Text */.Z.Text, {
        children: "Replies:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
        style: {
          marginRight: '0.5em'
        },
        children: comments.length + 1
      })
    })]
  });
};

function Description(_ref5) {
  var _country$data2, _country$data2$attrib, _country$data3, _country$data3$attrib, _country$data4, _country$data4$attrib;

  var articleData = _ref5.articleData;
  var title = articleData.title,
      description = articleData.description,
      image = articleData.image,
      country = articleData.country,
      shortDescription = articleData.short_description,
      updatedAt = articleData.updatedAt,
      shortQuery = articleData.short_query,
      user = articleData.user,
      comments = articleData.plugin_comments;
  (0,react.useEffect)(function () {
    var _country$data, _country$data$attribu;

    if (((_country$data = country.data) === null || _country$data === void 0 ? void 0 : (_country$data$attribu = _country$data.attributes) === null || _country$data$attribu === void 0 ? void 0 : _country$data$attribu.name) !== 'India' && true) {
      try {
        window.adsbygoogle = window.adsbygoogle || [];
        window.adsbygoogle.push({});
      } catch (e) {
        console.error(e);
      }
    }
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(card/* default */.Z, {
      title: /*#__PURE__*/(0,jsx_runtime.jsx)(TitleWithAuthor, {
        title: title,
        user: user
      }),
      style: {
        marginBottom: '1em'
      },
      actions: [/*#__PURE__*/(0,jsx_runtime.jsx)(CreatedAction, {
        user: user
      }, "user"), /*#__PURE__*/(0,jsx_runtime.jsx)(UpdatedAction, {
        updatedAt: updatedAt
      }, "update"), /*#__PURE__*/(0,jsx_runtime.jsx)(RepliesAction, {
        comments: comments
      }, "ellipsis")],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
          children: ((_country$data2 = country.data) === null || _country$data2 === void 0 ? void 0 : (_country$data2$attrib = _country$data2.attributes) === null || _country$data2$attrib === void 0 ? void 0 : _country$data2$attrib.name) !== 'India' && true && /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
              style: {
                width: '100%'
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("ins", {
                className: "adsbygoogle",
                style: {
                  display: 'block',
                  textAlign: 'center'
                },
                "data-ad-client": "ca-pub-9791786401617970",
                "data-ad-slot": "3254802733",
                "data-ad-format": "auto",
                "data-full-width-responsive": "true"
              })
            })
          })
        })
      }), shortQuery && /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
        style: {
          paddingBottom: '16px'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(typography/* default.Text */.Z.Text, {
            children: shortQuery
          })
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
        id: "acceptedAnswer",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Title, {
          level: 4,
          style: {
            color: '#1890ff'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CheckOutlined/* default */.Z, {
            style: {
              marginRight: '16px'
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: "Short Answer"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((react_markdown_default()), {
          children: shortDescription
        })]
      })
    }), ((_country$data3 = country.data) === null || _country$data3 === void 0 ? void 0 : (_country$data3$attrib = _country$data3.attributes) === null || _country$data3$attrib === void 0 ? void 0 : _country$data3$attrib.name) === 'India' && /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
        style: {
          minWidth: '250px'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          target: "_blank",
          href: "https://bit.ly/2YUNebF",
          rel: "noreferrer",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            width: 728,
            height: 90,
            alt: "",
            "data-src": "https://assets.fintrakk.com/Zerodha-Banner-728x90.png",
            src: "https://assets.fintrakk.com/Zerodha-Banner-728x90.png"
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(row/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Title, {
        level: 4,
        style: {
          color: '#1890ff'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MenuUnfoldOutlined/* default */.Z, {
          style: {
            marginRight: '16px'
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "Detailed Answer"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
        id: "suggestedAnswer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DetailsWithPhoto/* default */.Z, {
          details: description,
          image: image
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
      children: ((_country$data4 = country.data) === null || _country$data4 === void 0 ? void 0 : (_country$data4$attrib = _country$data4.attributes) === null || _country$data4$attrib === void 0 ? void 0 : _country$data4$attrib.name) === 'India' && /*#__PURE__*/(0,jsx_runtime.jsx)(shared_OptinInline, {
        id: "om-lsfvr08sg95yvtrnnysi-holder"
      })
    })]
  });
}
;// CONCATENATED MODULE: ./components/article/index.tsx












var Adsense = function Adsense() {
  return (
    /*#__PURE__*/
    // FTAppRightSideVertical
    _jsx("ins", {
      className: "adsbygoogle",
      style: {
        display: 'block'
      },
      "data-ad-client": "ca-pub-9791786401617970",
      "data-ad-slot": "6455735046",
      "data-ad-format": "auto",
      "data-full-width-responsive": "true"
    })
  );
};

function ArticleContent(_ref) {
  var _country$data, _country$data$attribu;

  var articleData = _ref.articleData,
      articleList = _ref.articleList;
  var _articleData$attribut = articleData.attributes,
      tags = _articleData$attribut.tags,
      broker = _articleData$attribut.broker,
      categories = _articleData$attribut.categories,
      country = _articleData$attribut.country;
  var related = 'api::article.article';
  var title = 'Related Discussions';
  var linkList = [];
  (0,react.useEffect)(function () {
    if (true) {
      try {
        window.adsbygoogle = window.adsbygoogle || [];
        window.adsbygoogle.push({});
      } catch (e) {
        console.error(e);
      }
    }
  }, []);

  if (articleList) {
    articleList.map(function (article) {
      linkList.push({
        href: '/article/[slug]/',
        as: "/article/".concat(article.slug, "/"),
        linkText: " ".concat(article.title),
        textDescription: "".concat(article.short_description)
      });
      return linkList;
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(row/* default */.Z, {
    className: "page-wrapper page",
    gutter: [16, 16],
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
      xs: 24,
      lg: 18,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
          span: 24,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
            articleData: articleData.attributes
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ArticleTags_ArticleTags, {
            tags: tags
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ArticleCategories, {
            categories: categories.data
          }), ((_country$data = country.data) === null || _country$data === void 0 ? void 0 : (_country$data$attribu = _country$data.attributes) === null || _country$data$attribu === void 0 ? void 0 : _country$data$attribu.name) === 'India' && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            target: "_blank",
            href: "https://bit.ly/2YUNebF",
            rel: "noreferrer",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              width: 728,
              height: 90,
              alt: "",
              "data-src": "https://assets.fintrakk.com/Zerodha-Banner-728x90.png",
              src: "https://assets.fintrakk.com/Zerodha-Banner-728x90.png"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(divider/* default */.Z, {
            style: {
              color: '#1890ff'
            },
            children: "Still got Doubts?"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Comments/* default */.Z, {
            articleData: articleData,
            related: related
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
      xs: 24,
      lg: 6,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
          span: 24,
          children: [broker.data && /*#__PURE__*/(0,jsx_runtime.jsx)(CompareBrokerQuickLinks/* default */.Z, {
            brokers: [broker.data]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(QuickLinks/* default */.Z, {
            title: title,
            linkList: linkList,
            country: articleData.attributes.country.data.attributes.name
          })]
        })
      })
    })]
  });
} // ArticleContent.propTypes = {
//   articleData: PropTypes.shape({
//     id: PropTypes.string.isRequired,
//     title: PropTypes.string.isRequired,
//     description: PropTypes.string.isRequired,
//     broker: PropTypes.shape({
//       slug: PropTypes.string.isRequired,
//     }),
//     tags: PropTypes.arrayOf(PropTypes.string),
//   }).isRequired,
//   articleList: PropTypes.arrayOf(
//     PropTypes.shape({
//       id: PropTypes.string.isRequired,
//       title: PropTypes.string.isRequired,
//       description: PropTypes.string.isRequired,
//       broker: PropTypes.shape({
//         name: PropTypes.string.isRequired,
//         slug: PropTypes.string.isRequired,
//       }),
//       tags: PropTypes.arrayOf(PropTypes.string),
//     })
//   ).isRequired,
// }
;// CONCATENATED MODULE: ./components/article/schema.tsx



function makeArticleSchema(articleData) {
  var _articleData$attribut = articleData.attributes,
      slug = _articleData$attribut.slug,
      title = _articleData$attribut.title,
      description = _articleData$attribut.description,
      comments = _articleData$attribut.plugin_comments,
      shortDescription = _articleData$attribut.short_description,
      createdAt = _articleData$attribut.createdAt;
  var commentCount = comments.length;
  var suggestedAnswer = [{
    '@type': 'Answer',
    text: description,
    url: "https://app.fintrakk.com/article/".concat(slug, "#suggestedAnswer")
  }];
  comments.forEach(function (comment) {
    var suggestedAnswerData = {
      '@type': 'Answer',
      text: comment.content,
      url: "https://app.fintrakk.com/article/".concat(slug, "#").concat(Date.parse(createdAt))
    };
    suggestedAnswer.push(suggestedAnswerData);
  });
  return {
    '@context': 'http://schema.org',
    '@type': 'QAPage',
    mainEntity: {
      '@type': 'Question',
      name: title,
      answerCount: commentCount + 2,
      acceptedAnswer: {
        '@type': 'Answer',
        text: shortDescription,
        url: "https://app.fintrakk.com/article/".concat(slug, "#acceptedAnswer")
      }
    },
    suggestedAnswer: suggestedAnswer
  };
}

function Schema(_ref) {
  var articleData = _ref.articleData;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
    type: "application/ld+json" // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(makeArticleSchema(articleData))
    }
  }, "jobJSON-".concat(articleData.id));
} // Schema.propTypes = {
//   articleData: PropTypes.shape({
//     id: PropTypes.string.isRequired,
//     title: PropTypes.string.isRequired,
//     description: PropTypes.string.isRequired,
//     shortDescription: PropTypes.string.isRequired,
//     created_at: PropTypes.string.isRequired,
//     article_comments: PropTypes.arrayOf(PropTypes.string.isRequired),
//   }).isRequired,
// }
// EXTERNAL MODULE: ./components/shared/schema/article.tsx
var schema_article = __webpack_require__(28262);
// EXTERNAL MODULE: ./graphql/generated/types.tsx
var types = __webpack_require__(13492);
// EXTERNAL MODULE: ./layouts/application.tsx + 4 modules
var application = __webpack_require__(8182);
// EXTERNAL MODULE: ./node_modules/nookies/dist/index.js
var dist = __webpack_require__(62286);
// EXTERNAL MODULE: ./shared/util.tsx + 6 modules
var util = __webpack_require__(77713);
;// CONCATENATED MODULE: ./pages/article/[slug].tsx



var _templateObject;















var title = function title(name) {
  return name;
};

var description = function description(name) {
  return name;
};

var UPDATE_ARTICLE_VIEWS = (0,lib/* gql */.Ps)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  mutation ($slug: String) {\n    createArticleViews(slug: $slug)\n  }\n"])));
var __N_SSG = true;
function Article(props) {
  var _image$file, _user$data, _user$data$attributes;

  var router = (0,next_router.useRouter)();
  var slug = router.query.slug,
      asPath = router.asPath;

  var _useMutation = (0,useMutation/* useMutation */.D)(UPDATE_ARTICLE_VIEWS),
      _useMutation2 = (0,slicedToArray/* default */.Z)(_useMutation, 1),
      ArticleViews = _useMutation2[0];

  var apolloClient = (0,useApolloClient/* useApolloClient */.x)();
  var propsData = props.data;

  var _useState = (0,react.useState)(propsData),
      data = _useState[0],
      setData = _useState[1];

  var allBrokers = data.all_brokers,
      article = data.article,
      navCalculators = data.nav_calculators,
      allPages = data.all_pages;
  var articleData = article.data[0]; // mutation to update article views

  var relatedArticles = articleData.attributes.relatedArticles;
  var _articleData$attribut = articleData.attributes,
      dataTitle = _articleData$attribut.title,
      dataDescription = _articleData$attribut.description,
      seoMeta = _articleData$attribut.seo_meta,
      image = _articleData$attribut.image,
      country = _articleData$attribut.country,
      user = _articleData$attribut.user;
  (0,react.useEffect)(function () {
    ArticleViews({
      variables: {
        slug: slug
      }
    });
    apolloClient.query({
      query: types/* ArticleCommentsDocument */.ht,
      variables: {
        relation: "api::article.article:".concat(data.article.data[0].id),
        sort: 'createdAt:desc'
      }
    }).then(function (res) {
      if ((0,util/* countComments */.Mw)(res.data.plugin_comments) !== (0,util/* countComments */.Mw)(data.article.data[0].attributes.plugin_comments)) {
        data.article.data[0].attributes.plugin_comments = res.data.plugin_comments;
        setData(data);
      }
    }); // handlePageLoad(apolloClient)

    var mapFrontendCountrySlug = function mapFrontendCountrySlug(countryVal) {
      switch (countryVal) {
        case 'usa':
          return 'us';

        case 'canada':
          return 'ca';

        case 'india':
          return 'in';

        default:
          return null;
      }
    };

    var cookies = (0,dist.parseCookies)();

    if (!cookies.country) {
      (0,dist.setCookie)(null, 'country', mapFrontendCountrySlug(country.data.attributes.name.toLowerCase()), {
        path: ['/'] // cookie path

      });
      (0,dist.destroyCookie)(null, 'country', {
        path: '/article',
        expires: new Date(0)
      });
    }
  }, []); // The following reset is required for SPA navigation but it causes errors. It is commented out for now.
  // useEffect(() => {
  //   return () => {
  //     // unmount optinmonster
  //     try {
  //       window.om107067_95746?.reset()
  //     } catch (e) {
  //       // do nothing
  //     }
  //   }
  // })

  var _ref = seoMeta || {},
      recordTitle = _ref.title,
      recordDescription = _ref.description;

  var pageTitle = title(dataTitle);
  var pageDescription = description(dataDescription);
  var images = [];

  if (image !== null && image !== void 0 && (_image$file = image.file) !== null && _image$file !== void 0 && _image$file.data) {
    var _image$file$data$, _image$file2, _image$file2$data$;

    var availableImage = ((_image$file$data$ = image.file.data[0]) === null || _image$file$data$ === void 0 ? void 0 : _image$file$data$.attributes.formats.large) || ((_image$file2 = image.file) === null || _image$file2 === void 0 ? void 0 : (_image$file2$data$ = _image$file2.data[0]) === null || _image$file2$data$ === void 0 ? void 0 : _image$file2$data$.attributes.url);
    images = [availableImage];
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(application/* default */.Z, {
    allBrokers: allBrokers.data,
    navCalculators: navCalculators.data,
    country: country.data,
    allPages: allPages.data,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: recordTitle || pageTitle
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Schema, {
        articleData: articleData
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description of the article",
        content: recordDescription || pageDescription
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(schema_article/* ArticleJsonLd */.d, {
      url: (0,util/* pageUri */.TI)(asPath),
      images: images,
      title: pageTitle,
      description: pageDescription,
      authorName: ((_user$data = user.data) === null || _user$data === void 0 ? void 0 : (_user$data$attributes = _user$data.attributes) === null || _user$data$attributes === void 0 ? void 0 : _user$data$attributes.username) || 'Fintrakk Admin'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ArticleContent, {
      articleData: articleData,
      articleList: relatedArticles
    })]
  });
}

/***/ }),

/***/ 98371:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/[slug]",
      function () {
        return __webpack_require__(30806);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5407,2453,3229,7752,2913,1945,2682,2769,6873,3679,6568,5239,1096,2139,4450,8182,3492,5428,9774,2888,179], function() { return __webpack_exec__(98371); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);